module.exports = __webpack_public_path__ + "img/plus-square.46a4fe35.svg";